module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_1.27ab5d5d.png";